import type { OrderOptionResponse } from "../../../../domain/types/orders";

export type OrderStatus =
  | "pending_payment"
  | "accepted"
  | "resubmission"
  | "production"
  | "production_complete"
  | "shipping"
  | "delivered"
  | "cancelled"
  | "refunded";

export type Order = {
  id: string;
  orderNumber: string;
  customerName: string;
  customerEmail: string;
  productName: string;
  quantity: number;
  unitPrice: number;
  totalAmount: number;
  status: OrderStatus;
  orderDate: string;
  /** Historical orders have no recorded submission timestamp. */
  isLegacyDate?: boolean;
  dueDate: string;
  memo?: string;
  /** 고객이 적은 작업물 제목 */
  workTitle?: string;
  options?: OrderOptionResponse[];
  /** 대표 파일 URL (예전 주문은 이것 하나만 있다) */
  files?: string;
  /** 결제 수단. 목록 응답에 없으면 null (부분 환불 카드 노출 판단에 쓴다) */
  paymentMethod: "TOSS" | "BANK_TRANSFER" | null;
  /** 고객이 올린 파일 전부 (업로드 순서, 첫 번째가 대표 파일) */
  attachments?: OrderAttachment[];
};

export type OrderAttachment = {
  url: string | null;
  fileName: string;
};

export interface CompanyMember {
  id: number;
  name: string;
  email: string;
  mobile: string;
}

export enum Status {
  PendingPayment, // 결제전
  Accepted, // 접수
  Resubmission, // 재접수
  Production, // 제작
  ProductionComplete, // 제작 완료
  Shipping, // 출고/배송
  Delivered, // 배송 완료
  Cancelled, // 취소
  Refunded, // 환불
}

